
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's0f3699a7bd401f61': `Noche`,
's3cd891731e99f7e6': `Alertas activas`,
's5de3f4978aaa2443': `Lista de alertas`,
's8119af112f965c78': `Brillantez`,
'sa7f8e003ff63ef9f': `No alertas activas`,
'se0955919920ee87d': `Día`,
's271aae29defa65a5': `ACK ALL`,
's253615bbc36ae2d7': `Auto brilliance`,
's6f01314ca1673b61': `Auto day - night`,
    };
  